/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { createContext } from 'react';

export interface ConfigContextValue {
  allowBlendSSO: boolean;
  featureFlags: Identity.API.FeatureFlags;
  auth: Identity.API.AuthConfig;
}

export const ConfigContext = createContext<Partial<ConfigContextValue>>({});
